import React, { PureComponent } from 'react';

import LabelContainer from '../containers/label-container';

const Name = ({ name, color = 'transparent' }) => (
    <span className={'labels-list-item' + (!name ? ' empty' : '')} style={{ color }}>
        <span className="labels-list-item-text">
            {name}
        </span>
    </span>
);

export default class LabelsList extends PureComponent { 
    static defaultProps = {
        labels: [],
        emptyText: null
    }

    render() {
        if (!this.props.labels.length && !this.props.children) {
            return this.props.emptyText;
        }

        return (
            <div className={'labels-list' + (this.props.withBackground ? ' with-background' : '') + (this.props.inverted ? ' inverted' : '')}>
                {
                    this.props.labels.map(labelId => <LabelContainer key={labelId} id={labelId}><Name /></LabelContainer>)
                }

                { this.props.children }
            </div>
        )
    }
}
